import { Backdrop, BackdropProps, CircularProgress, CircularProgressProps } from '@material-ui/core';
import React from 'react';

export type PageLoadingIndicatorProps = {
  BackdropProps?: BackdropProps;
  CircularProgressProps?: CircularProgressProps;
} & Omit<BackdropProps, 'open'>;

export const PageLoadingIndicator = ({ BackdropProps, CircularProgressProps, ...props }: PageLoadingIndicatorProps) => (
  <Backdrop
    role="status"
    aria-label="page loading"
    data-testid="page-loading"
    {...props}
    {...BackdropProps}
    invisible
    open
  >
    <CircularProgress color="primary" {...CircularProgressProps} />
  </Backdrop>
);

export default PageLoadingIndicator;
